module.exports = "<aside\n  *ngIf=\"!!(message || emphasisMessage)\"\n  [class.visible]=\"visible\"\n  [class.visibleAnimate]=\"visibleAnimate\"\n  [class.--action]=\"!!action\"\n>\n  <span class=\"message\">\n    <span *ngIf=\"!!message\">{{ message }} </span>\n    <i *ngIf=\"!!emphasisMessage\">{{ emphasisMessage }}</i>\n  </span>\n\n  <button\n    *ngIf=\"!!action\"\n    type=\"button\"\n    (click)=\"doAction()\"\n  >{{ action }}</button>\n</aside>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/snack-bar/snack-bar.html
// module id = ../../../../../src/app/components/snack-bar/snack-bar.html
// module chunks = 1